var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalmDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5147 11.4632C15.5147 11.609 15.5147 11.734 15.5147 11.8799C15.4105 11.7757 15.3064 11.6924 15.2022 11.609C13.6814 10.359 11.9314 9.46322 10.1189 8.96322C10.0355 6.87988 10.4522 4.81738 11.2647 2.94238C13.223 3.48405 15.098 4.46322 16.6605 5.85905C15.9105 7.56738 15.4939 9.48405 15.4939 11.484L15.5147 11.4632Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1611 11.4629C25.1611 15.6921 23.2861 19.4837 20.3278 22.0254C17.4736 19.5671 15.6403 15.9421 15.5361 11.8796C15.5361 11.7337 15.5361 11.6087 15.5361 11.4629C15.5361 9.46289 15.9528 7.54622 16.7028 5.83789C17.5361 3.92122 18.7861 2.23372 20.3486 0.900391C23.307 3.42122 25.182 7.23372 25.182 11.4629H25.1611Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3275 22.0249C16.4941 22.6916 12.39 21.7332 9.11914 19.0457C5.84831 16.3791 4.09831 12.5458 3.99414 8.62908C6.01497 8.27492 8.13997 8.37908 10.14 8.94158C11.9525 9.44158 13.7025 10.3374 15.2233 11.5874C15.3275 11.6708 15.4316 11.7541 15.5358 11.8582C15.64 15.9207 17.4733 19.5249 20.3275 22.0041V22.0249Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.14 11.4632C25.14 11.609 25.14 11.734 25.14 11.8799C25.2441 11.7757 25.3483 11.6924 25.4525 11.609C26.9733 10.359 28.7233 9.46322 30.5358 8.96322C30.6191 6.87988 30.2025 4.81738 29.39 2.94238C27.4316 3.48405 25.5566 4.46322 23.9941 5.85905C24.7441 7.56738 25.1608 9.48405 25.1608 11.484L25.14 11.4632Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3271 22.0249C24.1605 22.6916 28.2646 21.7332 31.5355 19.0457C34.8063 16.3791 36.5563 12.5458 36.6605 8.62908C34.6396 8.27492 32.5146 8.37908 30.5146 8.94158C28.7021 9.44158 26.9521 10.3374 25.4313 11.5874C25.3271 11.6708 25.223 11.7541 25.1188 11.8582C25.0146 15.9207 23.1813 19.5249 20.3271 22.0041V22.0249Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2028 37.1296L31.7028 28.9421C30.0361 27.3796 27.8486 26.5254 25.5778 26.5254H12.2236C10.9945 26.5254 9.97363 27.5254 9.97363 28.7754C9.97363 30.0046 10.9736 31.0254 12.2236 31.0254H19.7861",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.015 40.6921L25.1191 36.7962H14.3275C12.4525 36.7962 10.6608 36.0462 9.32747 34.7337L1.55664 26.9629C0.681641 26.0879 0.681641 24.6921 1.55664 23.8171H1.57747C2.45247 22.9212 3.84831 22.9212 4.72331 23.7962L9.70247 28.7754",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalmDown);
export default __webpack_public_path__ + "static/media/calm-down.f38d615acb18ab61558390615b33b212.svg";
export { ForwardRef as ReactComponent };